// extracted by mini-css-extract-plugin
export var breakpointXs = "550px";
export var colorGray = "#8e9287";
export var colorGrayDark = "#616161";
export var colorGrayDarker = "#272824";
export var colorGrayLight = "#e3e4e2";
export var colorGrayLighter = "#f2f3f2";
export var colorPrimary = "#a6ce3c";
export var colorSecondary = "#4f7802";
export var container = "layout-module--container--b93c7";
export var dark = "layout-module--dark--3a371";
export var header = "layout-module--header--395c7";
export var headerContainer = "layout-module--headerContainer--fdc84";
export var headerInner = "layout-module--headerInner--e6520";
export var layoutContainer = "layout-module--layoutContainer--94819";
export var light = "layout-module--light--986b7";
export var logo = "layout-module--logo--6e954";
export var logoLink = "layout-module--logo-link--07267";
export var main = "layout-module--main--3f0fd";
export var spacingLg = "32px";
export var spacingMd = "32px";
export var spacingSm = "16px";
export var spacingXl = "128px";
export var spacingXs = "8px";
export var spacingXxs = "4px";
export var twoColumns = "layout-module--two-columns--9e442";
export var vbr = "layout-module--vbr--1adb2";